import { parseXYAndKeepInfo } from 'xy-parser';
import { Analysis } from '../Analysis.js';
/**
 * Convert strings into JCAMP and add extra information
 * @param data - values to add to the file, usually a csv or tsv values
 * @param options
 */
export function fromText(data, options = {}) {
    const analysis = new Analysis();
    const { info = {}, parser = {} } = options;
    const parsed = parseXYAndKeepInfo(data, parser);
    const variables = {
        x: {
            data: parsed.data.x,
            units: info.xUnits || '',
            label: info.xLabel || '',
        },
        y: {
            data: parsed.data.y,
            units: info.yUnits || '',
            label: info.yLabel || '',
        },
    };
    analysis.pushSpectrum(variables);
    return analysis;
}
//# sourceMappingURL=fromText.js.map